(function() {


  // ------------- CONFIGURATION OPTIONS -------------- //
  // {
  //   alertType: String - 'success' || 'warn' || 'error' || 'info'
  //   title: String - The title of the alert,
  //   message: String - The message of the alert,
  //   suppressIcon: Boolean (optional) - pass false to hide the icon, otherwise it will show
  //   action: Object - Implementation is TBD
  // }


  var linkFunction = function($scope, element, attrs) {

  }

  var controllerFunction = function ($scope, UserSession, $filter, EM, $anchorScroll, CAD) {
    // console.log("Bank Info Controller Func: ", $scope);
    this.$onInit = function () {
      $scope.wcmContent = wcmContent;
    }
   
    $scope.isFEPClient = false;

    $scope.contactUs = function () {
      var getBrandingInfoObj = CAD.getBrandingInfos();
      if (getBrandingInfoObj != "" && getBrandingInfoObj != undefined){
        if (getBrandingInfoObj[0].clientInfo.clientName == 'FEP') {
          $scope.isFEPClient = true;
        }
      }
      cvsUtility.checkIfFepClient($scope.isFEPClient);
    };
    
  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/inlineAlert/inlineAlert.template.html',
      controller: controllerFunction,
      link: linkFunction,
      scope: {
        config: "=",
        reference:"=",
        blockid: '@'
      }
    }
  }

  controllerFunction.$inject = ["$scope", "userSession", "$filter", "errorModel",'$anchorScroll', 'cvsAppData']; angular.module('cvsApp').directive('inlineAlert', directiveFunction);

})();
